import {api} from "./api.service";

export const GetGoals = async (param) => {
    let res = await api.get("goals", { params: param });
    return res;
};

export const GetGoalsCategory = async (param) => {
    let res = await api.get("goals", { params: param });
    return res;
};


export const AddMonthTargets = async (data) => {
    let res = await api.post(`quarterly-targets/monthly`, data);
    return res;
};

export const AddWeekTargets = async (data) => {
    let res = await api.post(`quarterly-targets/weekly`, data);
    return res;
};

export const AddQuarTargets = async (data) => {
    let res = await api.post(`quarterly-targets/quarterly`, data);
    return res;
};

export const UpdateTarget = (id, data) => {
    return  api.patch(`quarterly-targets/${id}`,data);
}

export const DeleteTarget = (id) => {
    return api.delete(`quarterly-targets/${id}`);
}

export const AddAnnualBook = async (data) => {
    let res = await api.post(`quarterly-targets/book`, data);
    return res;
};
